var render = function render(){var _vm=this,_c=_vm._self._c;return (!this.isOnline)?_c('div',{staticClass:"offline-indicator-component label label-danger rounded-corner m-l-25"},[_c('i',{staticClass:"fa fa-times-circle"}),_vm._v(" OFFLINE ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }